import { Extension } from '@tiptap/core';
import { Plugin, PluginKey } from '@tiptap/pm/state';
import { EditorView } from '@tiptap/pm/view';

interface LinkPreviewOptions {
  onShowPreview: (url: string, rect: DOMRect) => void;
  onHidePreview: () => void;
}

export const LinkPreviewExtension = Extension.create<LinkPreviewOptions>({
  name: 'linkPreview',

  addOptions() {
    return {
      onShowPreview: () => {},
      onHidePreview: () => {},
    };
  },

  addProseMirrorPlugins() {
    return [
      new Plugin({
        key: new PluginKey('linkPreview'),
        view: (view: EditorView) => {
          const handleMouseOver = (event: MouseEvent) => {
            const target = event.target as HTMLElement;
            const link = target.closest('a');
            if (link) {
              const href = link.getAttribute('href');
              if (href) {
                const rect = link.getBoundingClientRect();
                this.options.onShowPreview(href, rect);
              }
            }
          };

          const handleMouseOut = () => {
            this.options.onHidePreview();
          };

          view.dom.addEventListener('mouseover', handleMouseOver);
          view.dom.addEventListener('mouseout', handleMouseOut);

          return {
            destroy: () => {
              view.dom.removeEventListener('mouseover', handleMouseOver);
              view.dom.removeEventListener('mouseout', handleMouseOut);
            },
          };
        },
      }),
    ];
  },
});
